import { useContext } from "react";

import { Context } from "../../managerStore";

const useAppOrderStatus = () => {
  const { state } = useContext(Context);

  const hasOnlyDlpOrder =
    !state.manager.school?.has_g4s_order &&
    state.manager.school?.has_dlp_order &&
    !state.manager.school?.has_g4s_basic_order;

  const hasDlpAndG4sBasicOrder =
    !state.manager.school?.has_g4s_order &&
    state.manager.school?.has_dlp_order &&
    state.manager.school?.has_g4s_basic_order;

  return { hasOnlyDlpOrder, hasDlpAndG4sBasicOrder };
};

export default useAppOrderStatus;
